import React, { useState, useEffect, useRef } from "react";
import "./styles/common.css";
import "./styles/base.css";
import "aos/dist/aos.css";
import "./styles/common.css";
import "./styles/board.css";
import "./styles/is.css";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import quick_02 from "./assets/quick-02.png";

const Header: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSitemapOpen, setIsSitemapOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");
  const openUlRef = useRef<HTMLUListElement>(null);

  const handleSitemapToggle = () => {
    setIsSitemapOpen(!isSitemapOpen);
  };

  // 상단으로
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // 스크롤에 따른 헤더 클래스 변경
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // 마우스 오버 핸들러
  const handleMouseOver = () => {
    setIsHovered(true);
    document.querySelector(".sec-header")?.classList.add("active");
  };

  // 마우스 리브 핸들러
  const handleMouseLeave = () => {
    setIsHovered(false);
    let newHeaderHeight =
      window.innerWidth > 481 ? `${100}px` : `${headerHeight}px`;
    setHeaderHeight(newHeaderHeight);
    document.querySelector(".sec-header")?.classList.remove("active");
  };

  // 메뉴 아이템 마우스오버 핸들러
  const handleMenuItemMouseOver = (menuName: any) => {
    if (openUlRef.current) {
      const blind_height = openUlRef.current.clientHeight;
      const headerHeight = `${blind_height + 85}px`;
      setHeaderHeight(headerHeight);
      setActiveMenu(menuName);
    }
  };

  // 메뉴 아이템 마우스리브 핸들러
  const handleMenuItemMouseLeave = () => {
    let newHeaderHeight =
      window.innerWidth > 481 ? `${100}px` : `${headerHeight}px`;
    setHeaderHeight(newHeaderHeight);
    setActiveMenu("");
  };

  // 메뉴 항목에 'open' 클래스를 추가할지 결정하는 함수
  const isMenuOpen = (menuName: any) => {
    return activeMenu === menuName;
  };

  // 모달 창 닫는 함수
  const closeModal = () => {
    setIsSitemapOpen(false);
  };

  // 모달 백그라운드를 클릭할 때 모달을 닫도록 이벤트 핸들러
  const handleModalBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeModal(); // 모달 창 닫는 함수 호출
    }
  };

  return (
    <>
      <section
        className={`sec-header ${isHovered || isScrolled ? "on" : ""}`}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        style={{ height: headerHeight }}
      >
        <a href="/" className="logo" title="주식회사 제닉스"></a>
        <ul className="nav" ref={openUlRef}>
          <li
            className={isMenuOpen("aboutUs") ? "open" : ""}
            onMouseOver={() => handleMenuItemMouseOver("aboutUs")}
            onMouseLeave={handleMenuItemMouseLeave}
          >
            <h2>ABOUT US</h2>
            <ul className="depth-5">
              <li>
                <h3>
                  <Link to="/abt_overview">Overview</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/abt_history">연혁</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/abt_vision">비전</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/abt_location">찾아오시는길</Link>
                </h3>
              </li>
            </ul>
          </li>
          <li
            className={isMenuOpen("businessArea") ? "open" : ""}
            onMouseOver={() => handleMenuItemMouseOver("businessArea")}
            onMouseLeave={handleMenuItemMouseLeave}
          >
            <h2>BUSINESS AREA</h2>
            <ul className="depth-3">
              <li>
                <h3>
                  <Link to="/busi_si">농림정보화</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/busi_security">정보보호</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/busi_consulting">컨설팅</Link>
                </h3>
              </li>
            </ul>
          </li>
          <li
            className={isMenuOpen("businessResult") ? "open" : ""}
            onMouseOver={() => handleMenuItemMouseOver("businessResult")}
            onMouseLeave={handleMenuItemMouseLeave}
          >
            <h2>BUSINESS RESULT</h2>
            <ul className="depth-5">
              <li>
                <h3>
                  <Link to="/rslt_outcome">구축실적</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/rslt_portfolio">포트폴리오</Link>
                </h3>
              </li>
            </ul>
          </li>
          <li
            className={isMenuOpen("contact") ? "open" : ""}
            onMouseOver={() => handleMenuItemMouseOver("contact")}
            onMouseLeave={handleMenuItemMouseLeave}
          >
            <h2>CONTACT</h2>
            <ul className="depth-5">
              <li>
                <h3>
                  <Link to="/contactUs">Contact Us</Link>
                </h3>
              </li>
            </ul>
          </li>
        </ul>

        <div className="lang">
          <a href="/">HOME</a>
          <a href="mailto:kissis@jenixinfo.co.kr">EMAIL</a>
        </div>
      </section>

      {/* 모달 백그라운드 */}
      {isSitemapOpen && (
        <div
          className="modal-background"
          onClick={handleModalBackgroundClick}
        ></div>
      )}

      {/* 모달 컴포넌트 */}
      <div id="sitemap" className={isSitemapOpen ? "open" : ""}>
        <ul>
          <li>
            <h2>ABOUT US</h2>
            <ul className="depth-1">
              <li>
                <h3>
                  <Link to="/abt_overview">Overview</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/abt_history">연혁</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/abt_vision">비전</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/abt_location">찾아오시는길</Link>
                </h3>
              </li>
            </ul>
          </li>
          <li>
            <h2>BUSINESS AREA</h2>
            <ul className="depth-2">
              <li>
                <h3>
                  <Link to="/busi_si">농림정보화</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/busi_security">정보보호</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/busi_consulting">컨설팅</Link>
                </h3>
              </li>
            </ul>
          </li>
          <li>
            <h2>BUSINESS RESULT</h2>
            <ul className="depth-3">
              <li>
                <h3>
                  <Link to="/rslt_outcome">구축실적</Link>
                </h3>
              </li>
              <li>
                <h3>
                  <Link to="/rslt_portfolio">포트폴리오</Link>
                </h3>
              </li>
            </ul>
          </li>
          <li>
            <h2>CONTACT</h2>
            <ul className="depth-4">
              <li>
                <h3>
                  <Link to="/contactUs">Contact Us</Link>
                </h3>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div
        className={`btn-category ${isHovered || isScrolled ? "on" : ""} ${
          isSitemapOpen ? "map" : ""
        }`}
        onClick={handleSitemapToggle}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
      <div className={`quick-menu ${isScrolled ? "on" : ""}`}>
        <a id="top_btn" onClick={handleScrollToTop}>
          <img src={quick_02} alt="상단으로" />
        </a>
      </div>
    </>
  );
};

export default Header;
